import type { PageRoute } from '../../page-route';
import { TimesheetPage } from './page';

export const route: PageRoute = { path: '/timesheets/:id', access: 'authed', Component: TimesheetPage };
